export default __webpack_public_path__ + "static/media/santa-maria-3.1d7d7039.jpg";